<template>
  <PortalPageShell
    :title="$t('menu.manageUser')"
    :subtitle="$t('portal.userManager')"
  >
    <ManageUser
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageUser from '../components/user/ManageUser.vue';

export default {
  components: {
    PortalPageShell,
    ManageUser,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
